import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import ParticipantList from './ParticipantList';
import { mislecAPI } from '../../../util/axios';

function Participants({ course, setOpen, setMessage, setSeverity, updateUser, setRevokeAccessId, revokeAccessModal, setRevokeAccessModal }) {
    const { t } = useTranslation();

    const [users, setUsers] = React.useState(null);

    React.useEffect(() => {
        if (users) return;
        fetchUsers();
    }, [users]);

    const fetchUsers = () => {
        //  Fetch users from the server
        mislecAPI.get(`/api/course/users/${course._id}`)
            .then(res => {
                setUsers(res.data.users);
            })
            .catch(error => {
                //  Notify user of error
                setMessage(error.response ? t(error.response.data.detail) : t('api.general.500'));
                setSeverity('error');
                setOpen(true);

                //  Expired session
                if (error.response)
                    if (error.response.data.detail === 'api.auth.verify.401')
                        updateUser(null);
            });
    }

    const changeStatus = (user, status) => {
        const data = {
            user_id: user._id,
            status: status
        };

        mislecAPI.post(`/api/course/enroll/${course._id}`, data)
            .then(res => {
                fetchUsers();

                setMessage(t(res.data.detail));
                setSeverity('success');
                setOpen(true);
            })
            .catch(error => {
                //  Notify user of error
                setMessage(error.response ? t(error.response.data.detail) : t('api.general.500'));
                setSeverity('error');
                setOpen(true);

                //  Expired session
                if (error.response)
                    if (error.response.data.detail === 'api.auth.verify.401')
                        updateUser(null);
            });
    }

    React.useEffect(() => {
        fetchUsers();
    }, [revokeAccessModal]);

    return (
        <>
            <Grid container sx={{ ml: 1, pr: 2 }}>
                <Grid container spacing={2} sx={{ mt: 1, mb: 2, pt: 0 }}>
                    <Grid item xs={12} sx={{ pt: '0px !important' }}>
                        <Typography variant='h5'>{t('course.tabs.participants.title')}</Typography>
                        <Typography variant='body2' sx={{ mt: 1 }}>
                            {t('course.tabs.participants.description')}
                        </Typography>
                    </Grid>
                    {users &&
                        <Grid item xs={12}>
                            <ParticipantList
                                users={users}
                                fetchUsers={fetchUsers}
                                changeStatus={changeStatus}
                                setRevokeAccessId={setRevokeAccessId}
                                setRevokeAccessModal={setRevokeAccessModal}
                                setOpen={setOpen}
                                setMessage={setMessage}
                                setSeverity={setSeverity}
                            />
                        </Grid>
                    }
                    {!users &&
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '390px' }}>
                                <CircularProgress />
                            </Box>
                        </Grid>
                    }
                </Grid>
            </Grid>
        </>
    );

}

export default Participants;